import { useRef } from 'react'

import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

export const ModalContentType = {
  DEFAULT: 'DEFAULT',
  NO_FRAME: 'NO_FRAME',
  FIXED: 'FIXED',
  TAB_FIXED: 'TAB_FIXED',
  FLEX_GROW: 'FLEX_GROW'
} as const

export type ModalContentType = (typeof ModalContentType)[keyof typeof ModalContentType]

interface Props extends ChildProps {
  type?: ModalContentType
  maxKeep?: boolean
  noBorder?: boolean
  scrollXHidden?: boolean
}

const ModalContent = ({
  children,
  type = ModalContentType.DEFAULT,
  maxKeep = false,
  noBorder = false,
  scrollXHidden = false
}: Props) => {
  const ref = useRef<HTMLDivElement>(null)

  const commonClass = clsx(
    type == ModalContentType.NO_FRAME
      ? 'p-0'
      : type == ModalContentType.FIXED
        ? 'px-4! py-3'
        : type == ModalContentType.TAB_FIXED
          ? 'px-4! pb-3'
          : type == ModalContentType.FLEX_GROW
            ? 'flex grow flex-col h-full'
            : 'p-4! flex flex-col gap-4',
    !noBorder &&
      (type == ModalContentType.FIXED || type == ModalContentType.TAB_FIXED) &&
      'border-primary border-b',
    scrollXHidden && 'overflow-x-hidden'
  )

  return (
    <div ref={ref} className={clsx('relative max-h-full w-full')}>
      <div
        className={clsx(
          'scrollbar-y overflow-y-auto',
          commonClass,
          type != ModalContentType.FLEX_GROW && 'max-h-[60vh]',
          maxKeep && 'shadow-scroll h-[70vh]'
        )}
      >
        {children}
      </div>
    </div>
  )
}

export default ModalContent
